let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("57z1p")).then(() => parcelRequire('dZa7Z'));